import { durationToMs } from './timeUtils';
import type { TimerDuration, TimerStatus } from './types';

export type TimerPlayPauseLabel = '开始' | '暂停';

export type TimerControlView = {
  hasTarget: boolean;
  isRunning: boolean;
  hasStarted: boolean;
  playPauseDisabled: boolean;
  resetDisabled: boolean;
  playPauseLabel: TimerPlayPauseLabel;
  /** 运行中为 pause，其余为 play */
  playPauseIcon: 'play' | 'pause';
};

/** 定时器播放/重置按钮的共享禁用与文案逻辑（画布与属性面板一致） */
export function getTimerControlView(
  target: TimerDuration,
  status: TimerStatus,
  elapsedMs: number,
): TimerControlView {
  const hasTarget = durationToMs(target) > 0;
  const isRunning = status === 'running';
  const hasStarted =
    elapsedMs > 0 || status === 'running' || status === 'paused' || status === 'completed';

  const playPauseLabel: TimerPlayPauseLabel = isRunning ? '暂停' : '开始';

  return {
    hasTarget,
    isRunning,
    hasStarted,
    playPauseDisabled: !hasTarget && !isRunning,
    resetDisabled: !hasStarted,
    playPauseLabel,
    playPauseIcon: isRunning ? 'pause' : 'play',
  };
}
